export const FieldNames = [
  "LocalizedStringField",
  "LocationPickerField",
  "ChipList",
  "DMQueryField",
  "StateRelationPickerField",
  "DocumentRelation",
  "LocalizedField",
  "MediaSelectorField",
  "ImageMapField",
  "ImageMapLeafletField",
  "QRCodeField",
  "DMSelectorField",
  "MemoriaAPIField",
  "KulturnavAutocompleteField",
  "FeatureToggleWrapperField",
  "RemoteClientSelectorField",
] as const;

export type FieldNamesList = (typeof FieldNames)[number];

export const WhiteListedFields: string[] = [
  "array",
  "boolean",
  "description",
  "one-of",
  "any-of",
  "null",
  "number",
  "object",
  "schema",
  "string",
  "title",
  "unsupported",
];
